import React from 'react';
import { Modal } from 'antd';
import EventCreateCard from 'components/EventCreateCard';

import './EventCreateDialog.scss';

const EventCreateDialog = props => {
	const { visible, onCreate, onCancel } = props;

	return (
		<Modal className="EventCreateDialog" open={visible} onCancel={onCancel} footer={null}>
			<EventCreateCard onCreate={onCreate} title="Create a New Event" />
		</Modal>
	);
};

export default EventCreateDialog;
